export default __webpack_public_path__ + "static/banner-how-to-get-out-of-debt-ec061ee6805af6ba5e6eaf6864655011.jpg";